module.exports = __webpack_public_path__ + "img/cangkuBtns.c8d91362.png";